var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("input", {
    directives: [
      {
        name: "mask",
        rawName: "v-mask",
        value: _vm.config,
        expression: "config",
      },
    ],
    attrs: { type: "text", id: _vm.id },
    domProps: { value: _vm.display },
    on: {
      input: _vm.onInput,
      keydown: function ($event) {
        if (
          !$event.type.indexOf("key") &&
          _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
        )
          return null
        $event.preventDefault()
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }